<template>
  <div 
    class="px-4 sm:px-6 py-4 fixed w-full z-10 animate-fade-in transition-all duration-300"
    :class="{'bg-background': isScrolled || mobileMenuOpen}"
  >
    <nav class="max-w-7xl mx-auto px-3 sm:px-6 py-3">
      <div class="flex justify-between items-center">
        <div class="flex items-center">
          <router-link to="/" class="flex items-center" v-if="!isAuthRoute">
            <img 
              :src="isDashboardRoute ? '/media/crd_logo/logo_nobg.png' : '/media/crd_logo/logo_nobg.png'"
              alt="Carddy Logo" 
              class="h-9 sm:h-9 object-contain mr-2"
            />
          </router-link>
        </div>
        
        <!-- Mobile menu button -->
        <button 
          class="md:hidden text-white focus:outline-none"
          @click="toggleMobileMenu"
          aria-label="Toggle menu"
        >
          <font-awesome-icon :icon="mobileMenuOpen ? 'times' : 'bars'" class="text-xl" />
        </button>
        
        <!-- Desktop Navigation -->
        <div class="hidden md:flex items-center space-x-8">
          <a href="/#features" class="text-gray-300 hover:text-white transition-colors duration-300" v-if="!isAuthRoute">О нас</a>
          <a href="/#pricing" class="text-gray-300 hover:text-white transition-colors duration-300" v-if="!isAuthRoute">Стоимость</a>
          <a href="/#faq" class="text-gray-300 hover:text-white transition-colors duration-300" v-if="!isAuthRoute">FAQ</a>
<!--          <a href="/#blog" class="text-gray-300 hover:text-white transition-colors duration-300" v-if="!isAuthRoute">Блог</a>-->
          <router-link to="/login" class="text-gray-300 hover:text-white px-4 py-2 rounded-full border border-gray-600 transition-colors duration-300" v-if="!isLoginRoute && count==0">Войти</router-link>
          <router-link to="/signup" class="bg-white text-black px-4 py-2 rounded-full font-medium hover:bg-gray-100 transition-colors duration-300" v-if="!isSignupRoute && count==0">Зарегистрироваться</router-link>
          <router-link to="/dashboard" class="text-gray-300 hover:text-white px-4 py-2 rounded-full border border-gray-600 transition-colors duration-300" v-if="count==1">Личный кабинет</router-link>
        </div>
      </div>
    </nav>
    
    <!-- Mobile Navigation Menu -->
    <div 
      class="md:hidden fixed inset-0 bg-background z-20 transition-all duration-300 ease-in-out"
      :class="mobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'"
      style="top: 72px;"
    >
      <div class="flex flex-col items-center pt-8 pb-16 px-6 space-y-6 text-center">
        <a 
          href="/#features" 
          class="text-gray-300 hover:text-white transition-colors duration-300 text-xl py-3 w-full border-b border-gray-800" 
          v-if="!isAuthRoute"
          @click="closeMobileMenu"
        >
          О нас
        </a>
        <a 
          href="/#pricing" 
          class="text-gray-300 hover:text-white transition-colors duration-300 text-xl py-3 w-full border-b border-gray-800" 
          v-if="!isAuthRoute"
          @click="closeMobileMenu"
        >
          Стоимость
        </a>
        <a 
          href="/#faq" 
          class="text-gray-300 hover:text-white transition-colors duration-300 text-xl py-3 w-full border-b border-gray-800" 
          v-if="!isAuthRoute"
          @click="closeMobileMenu"
        >
          FAQ
        </a>
<!--        <a -->
<!--          href="/#blog" -->
<!--          class="text-gray-300 hover:text-white transition-colors duration-300 text-xl py-3 w-full border-b border-gray-800" -->
<!--          v-if="!isAuthRoute"-->
<!--          @click="closeMobileMenu"-->
<!--        >-->
<!--          Блог-->
<!--        </a>-->
        <div class="flex flex-col space-y-4 w-full pt-4">
          <router-link 
            to="/login" 
            class="text-gray-300 hover:text-white px-4 py-3 rounded-full border border-gray-600 transition-colors duration-300 w-full" 
            v-if="!isLoginRoute"
            @click="closeMobileMenu"
          >
            Войти
          </router-link>
          <router-link 
            to="/signup" 
            class="bg-white text-black px-4 py-3 rounded-full font-medium hover:bg-gray-100 transition-colors duration-300 w-full" 
            v-if="!isSignupRoute"
            @click="closeMobileMenu"
          >
            Зарегистрироваться
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'TheHeader',

  data() {
    return {
      count: 0,
    };
  },

  setup() {
    const route = useRoute()
    const isScrolled = ref(false)
    const mobileMenuOpen = ref(false)
    
    const handleScroll = () => {
      if (window.scrollY > 10) {
        isScrolled.value = true
      } else {
        isScrolled.value = false
      }
    }
    
    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value
      if (mobileMenuOpen.value) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
    
    const closeMobileMenu = () => {
      mobileMenuOpen.value = false
      document.body.style.overflow = ''
    }
    
    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
      // Check initial scroll position
      handleScroll()
    })
    
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
      document.body.style.overflow = ''
    })
    
    const isAuthRoute = computed(() => {
      return route.path.includes('/login') || route.path.includes('/signup') || route.path.includes('/reset-password')
    })
    
    const isLoginRoute = computed(() => {
      return route.path.includes('/login')
    })
    
    const isSignupRoute = computed(() => {
      return route.path.includes('/signup')
    })
    
    const isDashboardRoute = computed(() => {
      return route.path.includes('/dashboard')
    })
    
    return {
      isScrolled,
      isAuthRoute,
      isLoginRoute,
      isSignupRoute,
      isDashboardRoute,
      mobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu
    }
  },

  created() {
    if (this.$cookies.isKey("username_carddy")) {
      this.count = 1;
    }
  },
})
</script>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .mobile-menu-open {
    overflow: hidden;
  }
}
</style>
